module.exports = __webpack_public_path__ + "img/activity_3_2.ff0dbf63.png";